enum ChannelType {
    Ecom = 'Ecom',
    Lengow = 'Lengow',
}

export default ChannelType;